import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_backer_center_payments_preview = _resolveComponent("backer-center-payments-preview")
  const _component_backer_center_section = _resolveComponent("backer-center-section")
  const _component_backer_center_payments_tabs = _resolveComponent("backer-center-payments-tabs")

  return (_openBlock(), _createBlock(_component_backer_center_payments_tabs, {
    "current-search-type": $data.currentSearchType,
    "item-limit": 10,
    onTabSelected: $options.onTabSelected
  }, {
    header: _withCtx(() => [
      _createVNode(_component_base_title, {
        as: "h2",
        level: "h2"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Resources.BackerCenter.SectionPaymentsHeader), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_backer_center_section, {
        class: "_mt-4",
        "link-more": $options.linkMore,
        "label-more": _ctx.Resources.BackerCenter.ViewAllPaymentsLabel,
        "is-loading": _ctx.isProcessing,
        "is-empty": !$options.hasPayments,
        "has-empty-action": false,
        "empty-title": _ctx.Resources.BackerCenter.PaymentsEmptyStateHeader,
        "empty-description": _ctx.Resources.BackerCenter.PaymentsEmptyStateParagraph
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mappedPayments, (payment) => {
            return (_openBlock(), _createBlock(_component_backer_center_payments_preview, _mergeProps({
              key: payment.paymentID
            }, { ref_for: true }, payment), null, 16 /* FULL_PROPS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["link-more", "label-more", "is-loading", "is-empty", "empty-title", "empty-description"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["current-search-type", "onTabSelected"]))
}